export default __webpack_public_path__ + "static/management-mobile-34e65a2995c0c12cb201ea2d7d15d640.svg";